/**
 * @generated SignedSource<<ec393969242d522638b2c965f60f056b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NoWorkspacePersonalSettingsViewQuery$variables = Record<PropertyKey, never>;
export type NoWorkspacePersonalSettingsViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PersonalSettings">;
};
export type NoWorkspacePersonalSettingsViewQuery = {
  response: NoWorkspacePersonalSettingsViewQuery$data;
  variables: NoWorkspacePersonalSettingsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NoWorkspacePersonalSettingsViewQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PersonalSettings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NoWorkspacePersonalSettingsViewQuery",
    "selections": [
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "aaid"
          },
          {
            "concreteType": "TeamResponseBody",
            "kind": "LinkedField",
            "name": "slackTeams",
            "plural": true,
            "selections": (v0/*: any*/)
          },
          {
            "concreteType": "TenantResponseBody",
            "kind": "LinkedField",
            "name": "msteamsTenants",
            "plural": true,
            "selections": (v0/*: any*/)
          },
          {
            "concreteType": "UserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "email"
              }
            ]
          },
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "emailReminderEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "slackReminderEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "msteamsReminderEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "emailSummaryEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "slackSummaryEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "msteamsSummaryEnabled"
              },
              (v1/*: any*/)
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d946e15ad5df93ce546b8860ddd437ae",
    "id": null,
    "metadata": {},
    "name": "NoWorkspacePersonalSettingsViewQuery",
    "operationKind": "query",
    "text": "query NoWorkspacePersonalSettingsViewQuery {\n  ...PersonalSettings\n}\n\nfragment ConnectionInfo_data on User {\n  aaid\n  slackTeams {\n    name\n  }\n  msteamsTenants {\n    name\n  }\n}\n\nfragment IntegrationSettings_data on User {\n  aaid\n  slackTeams {\n    __typename\n  }\n  msteamsTenants {\n    __typename\n  }\n  pii {\n    email\n  }\n  ...NotificationSettingsForm_data\n}\n\nfragment NotificationSettingsForm_data on User {\n  preferences {\n    emailReminderEnabled\n    slackReminderEnabled\n    msteamsReminderEnabled\n    emailSummaryEnabled\n    slackSummaryEnabled\n    msteamsSummaryEnabled\n    id\n  }\n  ...ConnectionInfo_data\n  slackTeams {\n    name\n  }\n  msteamsTenants {\n    name\n  }\n}\n\nfragment PersonalSettings on Query {\n  currentUser {\n    ...IntegrationSettings_data\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c8bdbdc3c84e9afb18df7902fb2cde8";

export default node;
